import { render, staticRenderFns } from "./SideMenuLinkSP.vue?vue&type=template&id=4f0d466a&scoped=true"
import script from "./SideMenuLinkSP.vue?vue&type=script&lang=ts"
export * from "./SideMenuLinkSP.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuLinkSP.vue?vue&type=style&index=0&id=4f0d466a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d466a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f0d466a')) {
      api.createRecord('4f0d466a', component.options)
    } else {
      api.reload('4f0d466a', component.options)
    }
    module.hot.accept("./SideMenuLinkSP.vue?vue&type=template&id=4f0d466a&scoped=true", function () {
      api.rerender('4f0d466a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/SideMenuLinkSP.vue"
export default component.exports